export const toInventoryNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

export const buildInventoryProductUpdatePayload = (product) => ({
  _id: product?._id,
  Metal: product?.Metal || "",
  Color: product?.Color || product?.color || "",
  Size: product?.Size || "",
  GrossWt: toInventoryNumber(product?.GrossWt),
  NetWt: toInventoryNumber(product?.NetWt),
  additional_note:
    product?.additional_note ?? product?.extra_po_information ?? "",
  Stones: product?.Stones || [],
  PriceDetails: product?.PriceDetails || [],
});
